// API Configuration — single source of truth for the backend base URL.
// Both the REST ApiClient and the SSE hooks read from API_CONFIG.BASE_URL.
// VITE_API_BASE_URL should point to the API root WITHOUT /v1 —
// e.g. https://us-central1-contextfiregcp.cloudfunctions.net/api
// All service paths include the /v1 prefix themselves.
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001',
} as const
